import { ScrollContext, ScrollContextSettings } from '@/contexts/scroll/helpers';
import { useContext } from 'react';

const useScroll = () => useContext<ScrollContextSettings>(ScrollContext);

export default useScroll;
